type Money = { formatted?: string; amount?: number } | null | undefined

export type OverdueLine = {
  pay_app_id?: number
  pay_app_number?: number | string
  project_name?: string
  amount?: Money
  days_late?: number
  label?: string
}

export type OverdueDigest = {
  overdue_total?: Money
  overdue_count?: number
  not_yet_due_total?: Money
  not_yet_due_count?: number
  lines?: OverdueLine[] | null
}

function moneyText(m: Money): string {
  if (m?.formatted) return m.formatted
  if (m?.amount != null) {
    return `$${Number(m.amount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
  }
  return '$0.00'
}

function payLabel(n: number | undefined): string {
  return n === 1 ? 'pay app' : 'pay apps'
}

export default function SorenOverdueCard({
  digest,
  onDraftFollowups,
}: {
  digest?: OverdueDigest | null
  onDraftFollowups?: () => void
}) {
  const overdueN = digest?.overdue_count ?? 0
  const dueN = digest?.not_yet_due_count ?? 0
  const lines = Array.isArray(digest?.lines) ? digest.lines : []
  return (
    <div className="soren-overdue-answer" data-testid="soren-overdue-answer">
      <p data-testid="soren-overdue-total">
        Overdue: {moneyText(digest?.overdue_total)} across {overdueN} {payLabel(overdueN)}
      </p>
      <p data-testid="soren-not-yet-due-total">
        Billed, not yet due: {moneyText(digest?.not_yet_due_total)} across {dueN} {payLabel(dueN)}
      </p>
      <ul className="soren-fact-list" data-testid="soren-overdue-lines">
        {lines.map((line) => (
          <li key={line.pay_app_id ?? line.label} data-testid="soren-overdue-line">
            {line.label || `${line.project_name || 'Project'} · Pay app ${line.pay_app_number}`}
          </li>
        ))}
      </ul>
      <button
        type="button"
        className="cr-btn dark"
        data-testid="soren-draft-followups"
        onClick={() => onDraftFollowups?.()}
      >
        Draft follow-ups
      </button>
    </div>
  )
}
